module.exports = __webpack_public_path__ + "static/media/card-ags.84513894.png";